import type { ReactNode } from "react";

export const FILTER_PANEL_FORM_CLASS = "filter-panel-form";

export type FilterPanelLayout =
  | "pickers"
  | "transactions"
  | "preliquidation"
  | "pricing"
  | "slots";

export type FilterPanelProps = {
  title: string;
  layout: FilterPanelLayout;
  children: ReactNode;
  testId?: string;
  isOpen?: boolean;
  collapseTable?: (collapse: boolean) => void;
};
